

import { Button, Image,Box } from '@chakra-ui/react'
import React from 'react'
import { Link as RouterLink  } from 'react-router-dom'
const NotFound = () => {
  return (
    //  <Image src="https://img.freepik.com/premium-vector/page-found-error-404-landing-page_95505-93.jpg?w=1060" alt="not found page" 
      
    //  />
    <Box> 
     <RouterLink to="/"> 
     <Image src="https://img.freepik.com/free-vector/error-404-concept-landing-page_52683-12757.jpg?w=996&t=st=1677403291~exp=1677403891~hmac=23f665c6657aae7c8b671d5e4e60517b21cd24c42014991d2ef3dadaa85dfd41" alt="not found page" 
      w={"100%"} h={640}
     />
       </RouterLink>
     </Box>
  )
}

export default NotFound